import { Table, Pagination } from "flowbite-react";
import InfluencerRow from "./InfluencerRow";

const Influencers = ({ lookalikes, page, totalPages, onPageChange }) => {
  if (lookalikes.length === 0) return null;

  const columns = [
    { label: 'Influencer' },
    { label: 'Status' },
    { label: 'Last Interaction Date' },
  ];

  return (
    <>
      <div className="overflow-x-auto">
        <Table>
          <Table.Head>
            {columns.map((column, key) => (
              <Table.HeadCell key={key}>{column.label}</Table.HeadCell>
            ))}
          </Table.Head>
          <Table.Body className="divide-y">
            {lookalikes.map((lookalike) => (
              <InfluencerRow
                key={lookalike._id}
                lookalike={lookalike}
              />
            ))}
          </Table.Body>
        </Table>
        {totalPages > 1 && (
          <div className="sticky bottom-0 right-0 w-full items-center border-t border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex sm:justify-between">
            <Pagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default Influencers;
